import { Box } from "@mui/material";
import React from "react";
import ItemDetailViewSection, {
  Item,
  ItemDetail,
} from "../../../common/item/ItemDetailViewSection";
import ItemsDetailViewSection, {
  ItemsDetail,
} from "../../../common/item/ItemsDetailViewSection";
import ScrollSpyTabs from "../../../common/nav/ScrollSpyTabs";
import { Data } from "../../../store/merchantStaging/types";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../common/StaticConfigProvider";
import { get } from "lodash";
import useUserAccess from "../../../effects/useUserAccess";
import ItemsDetailConfigurationViewSection from "../../../common/item/ItemsDetailConfigurationViewSection";

interface MerchantViewDetailProps {
  merchantStageData: Data;
  toolTips?: { merchants?: { options?: Record<string, string> } };
}

const MerchantStageViewDetail = (props: MerchantViewDetailProps) => {
  const { attributes: at } = props.merchantStageData?.terminal;
  const access = useUserAccess();
  // const SectionAccess = get(access, "Merchant.SectionAccess", {});
  // const MerchantInfoAccess = get(SectionAccess, "MerchantInfo.Access", {
  //   R: false,
  //   U: false,
  // });
  const merchantData: ItemsDetail = {
    sectionName:"Merchant",
    itemsData: [
      {
      sectionName: "Merchant IDs",
      itemData: [
        { fieldName: "TID", fieldValue: props.merchantStageData.TID },
        { fieldName: "MID", fieldValue: props.merchantStageData.MID },
        
      ]
    },
    {
      sectionName: "Merchant Info",
      itemData: [
        { fieldName: "Feature Cash Out", fieldValue: at.FeatureCashOut},
        { fieldName: "Feature Pre Auth", fieldValue: at.FeaturePreAuth },
        { fieldName: "Feature Refund", fieldValue: at.FeatureRefund },
        { fieldName: "Feature MOTO", fieldValue: at.FeatureMOTO },
        { fieldName: "Visa MCR Thresold", fieldValue: at.VisaMCRThreshold },
        { fieldName: "Master card Threshold", fieldValue: at.MastercardMCRThreshold },
        { fieldName: "MCC", fieldValue: at.MCC },
        { fieldName: "Auto Software Update Enabled", fieldValue: at.AutoSoftwareUpdateEnabled },
        { fieldName: "BP Card Suppord", fieldValue: at.BpCardSupport },
        { fieldName: "Cab Charge Fast Card Enabled", fieldValue: at.CabchargeFastCardEnabled },
        { fieldName: "Cloud POS", fieldValue: at.CloudPOS },
        { fieldName: "Customer Receipt Print", fieldValue: at.CustomerReceiptPrint },
        { fieldName: "Feature A2B Taxi Mode Enabled", fieldValue: at.FeatureA2BTaxiModeEnabled },
        { fieldName: "Feature BP Gift Cards", fieldValue: at.FeatureBPGiftCards },
        { fieldName: "Feature Cab Charge Fast Card Enabled", fieldValue: at.FeatureCabchargeFastCardEnabled },
        { fieldName: "Feature Completion", fieldValue: at.FeatureCompletion },
        { fieldName: "Feature Crypto Dot Com Enabled", fieldValue: at.FeatureCryptoDotComEnabled },
        { fieldName: "Feature Crypto Dot Com Refunds Enabled", fieldValue: at.FeatureCryptoDotComRefundsEnabled },
        { fieldName: "Feature DRC Loyalty Cash Password Protect", fieldValue: at.FeatureDRCLoyaltyCashPasswordProtect },
        { fieldName: "Feature DRC Loyalty Enabled", fieldValue: at.FeatureDRCLoyaltyEnabled },
        { fieldName: "Feature Fixed Amount Entry Enabled", fieldValue: at.FeatureFixedAmountEntryEnabled },
        { fieldName: "Feature Last Settle", fieldValue: at.FeatureLastSettle },
        { fieldName: "Feature Mentor Lite", fieldValue: at.FeatureMentorLite },
        { fieldName: "Feature Partial Payment Enabled", fieldValue: at.FeaturePartialPaymentEnabled },
        { fieldName: "Feature Pre Settle", fieldValue: at.FeaturePreSettle },
        { fieldName: "Feature Pur With Cash", fieldValue: at.FeaturePurWithCash },
        { fieldName: "Feature Pur With Tip", fieldValue: at.FeaturePurWithTip },
        { fieldName: "Fixed Amount Entry Use User Supplied", fieldValue: at.FixedAmountEntryUseUserSupplied },
        { fieldName: "Location", fieldValue: at.Location },
        { fieldName: "POS App", fieldValue: at.POSApp },
        { fieldName: "Receipt", fieldValue: at.Receipt },
        { fieldName: "Receipt Merchants", fieldValue: at.ReceiptMerchant },
        { fieldName: "Standalone", fieldValue: at.Standalone },
      ]
    }
    ]
  }

  return (
    <Box>
      <ScrollSpyTabs
        tabsInScroll={[
          {
            label: "Staged Terminal Info",
            component: (
              <ItemsDetailConfigurationViewSection

                sectionName={merchantData.sectionName}
                itemsData={merchantData.itemsData}
                isColumn={true}
                isRestricted={false}
              />
            ),
          },
       ]}
      />
    </Box>
  );
};

const MerchantViewDetailHoc = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: MerchantViewDetailProps) => {
    return {
      ...ownProps,
    };
  }
)(MerchantStageViewDetail);

const ConnectedMerchantViewDetailHoc = (props: MerchantViewDetailProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <MerchantViewDetailHoc {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedMerchantViewDetailHoc;
